import { BaseComponent } from "utils/base-component"

export class TaggedNewsPost extends BaseComponent {
  static cssClass = "tagged-news-post"

  init() {
    this.linkNewsPosts()
  }

  private linkNewsPosts() {
    const article = this.root.querySelector<HTMLElement>(`.${this.cssClass}__post[data-link]`)

    article.addEventListener("click", (event) => {
      const target = event.target as HTMLElement
      if (target.closest("a")) {
        return
      }

      const link = article.getAttribute("data-link")
      if (link) {
        window.open(link, "_blank", "noopener")
      }
    })
  }
}
